import React from 'react';
import { UseFormRegister, FieldErrors } from 'react-hook-form';
import Input from '../../../components/Form/Input';
import Select from '../../../components/Form/Select';
import { OutTransactionFormData } from './outTransactionTypes';

interface OutBankDetailsSectionProps {
  register: UseFormRegister<OutTransactionFormData>;
  errors: FieldErrors<OutTransactionFormData>;
  selectedBankId: string;
  selectedTransferType: string;
  getSelectedBankName: () => string;
}

const OutBankDetailsSection: React.FC<OutBankDetailsSectionProps> = ({
  register,
  errors,
  selectedBankId,
  selectedTransferType,
  getSelectedBankName,
}) => {
  return (
    <div className="bg-gray-50 rounded-xl p-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
        <svg className="w-5 h-5 mr-2 text-ocean-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        Bank Transaction Details
      </h3>

      <div className="space-y-6">
        <div className="bg-blue-50 p-4 rounded-lg">
          <p className="text-sm text-blue-800">
            <strong>Selected Bank:</strong> {getSelectedBankName()}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <Input
            label="Transaction Amount"
            type="number"
            step="0.01"
            {...register('amount', {
              required: 'Amount is required',
              valueAsNumber: true,
              min: { value: 0.01, message: 'Amount must be positive' }
            })}
            error={errors.amount?.message}
            placeholder="0.00"
          />
          <div></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <Select
            label="Transfer Type"
            {...register('transferType', { required: selectedBankId ? 'Transfer type is required' : false })}
            options={[
              { value: 'transfer', label: 'Bank Transfer' },
              { value: 'check', label: 'Check (شيك)' },
              { value: 'cash', label: 'Cash' }
            ]}
            error={errors.transferType?.message}
          />

          <Input
            label="Transaction Date"
            type="date"
            {...register('transactionDate', { required: selectedBankId ? 'Transaction date is required' : false })}
            error={errors.transactionDate?.message}
          />
        </div>

        {selectedTransferType === 'check' && (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <Input
              label="Check Number"
              {...register('checkNumber', {
                required: selectedTransferType === 'check' ? 'Check number is required for check transactions' : false
              })}
              error={errors.checkNumber?.message}
              placeholder="Enter check number"
            />
            <div></div>
          </div>
        )}

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <Input
            label="Recipient Name"
            {...register('recipientName', { required: selectedBankId ? 'Recipient name is required' : false })}
            error={errors.recipientName?.message}
            placeholder="Enter recipient name"
          />
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default OutBankDetailsSection;
